import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUser } from '../../selectors/user';
import { canUserCreateRequest } from '../../services/newbuildingBroker';
import { setFormStep } from '../../slices/requestFormV2';
import { IThunkApi } from '../../types/redux/store';
import { EFormStep } from '../../types/requestForm/requestFormV2';
import { getCianSource, isNewbuildingBrokerCianSource } from '../../utils/cianSource';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const canUserCreateRequestAction = createAsyncThunk<boolean, void, IThunkApiExtended>(
  'requestButton/canUserCreateRequest',
  async (_, { getState, extra: context, dispatch }) => {
    const { httpApi, logger } = context;

    const state = getState();
    const user = selectUser(state);
    const cianSource = getCianSource();

    if (!user.isAuthenticated || !cianSource || !isNewbuildingBrokerCianSource(cianSource, context.config)) {
      return true;
    }

    try {
      const response = await canUserCreateRequest({ httpApi });

      if (!response.canCreate) {
        dispatch(setFormStep(EFormStep.BookingExists));
      }

      // TODO: Можно убрать возврат, когда будут удалять старую версию лендинга.
      return response.canCreate;
    } catch (ex) {
      logger.error(ex, {
        domain: 'actions/newbuildingBroker/canUserCreateRequest',
      });

      throw ex;
    }
  },
);
